export const GalleryThumbnails = ({ images, title, kind, activeIndex, select, openAt }) => {
  if (images.length < 2) return null;
  return (
    <div className="mt-4 grid grid-cols-5 sm:grid-cols-6 gap-2">
      {images.slice(0, 12).map((url, index) => (
        <button
          key={url}
          type="button"
          data-testid={`${kind}-thumbnail-${index}`}
          aria-label={`${title} - ${index + 1}`}
          aria-pressed={index === activeIndex}
          onClick={() => select(index)}
          className={`relative aspect-square overflow-hidden rounded-lg border-2 transition-all duration-300 ${
            index === activeIndex ? 'border-accent opacity-100' : 'border-white/5 opacity-60 hover:opacity-100 hover:border-white/30'
          }`}
        >
          <img src={url} alt={`${title} ${index + 1}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
        </button>
      ))}
      {images.length > 12 && (
        <button
          type="button"
          data-testid={`${kind}-more-photos-button`}
          onClick={() => openAt(12)}
          className="relative aspect-square rounded-lg border-2 border-border bg-input text-white/70 hover:border-primary/60 hover:text-white text-[12px] font-medium transition flex items-center justify-center"
        >
          +{images.length - 12}
        </button>
      )}
    </div>
  );
};